var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M25,11H2c-1.1,0-2-0.9-2-2s0.9-2,2-2h23c1.1,0,2,0.9,2,2S26.1,11,25,11z"})),React.createElement("g",{"key":1},React.createElement("path",{"d":"M18.1,18c-0.5,0-1-0.2-1.4-0.6c-0.8-0.8-0.8-2,0-2.8L22.2,9l-5.6-5.6c-0.8-0.8-0.8-2,0-2.8c0.8-0.8,2-0.8,2.8,0l7,7\n\t\tc0.8,0.8,0.8,2,0,2.8l-6.9,7C19.1,17.8,18.6,18,18.1,18z"}))]);
}

Arrow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 27 18"};

module.exports = Arrow;

Arrow.default = Arrow;
